import styled from "styled-components";

export const StyledWarningInfo = styled.div`
    position: absolute;
    border-radius: 10px;
    max-width: 80%;
    width: 100%;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);

    background: ${({ theme }) => `${theme.colors.black}80`};
    padding: 16px;

    svg {
        color: ${({ theme }) => theme.colors.warning};
        font-size: 24px;
    }
`;
